import { createSlice } from "@reduxjs/toolkit";

const hsCodesStore = createSlice({
  name: "hsCodes",
  initialState: {
    root: [], // root initial list
    expandedNodes: {}, // children for expanded nodes
    rootLoading: false,
    loading: false,
    error: null,
  },
  reducers: {
    setHsRoot(state, action) {
      state.root = action.payload;
    },
    setChildren(state, action) {
      const { parentCode, children } = action.payload;
      state.expandedNodes[parentCode] = children;
    },
    clearHsCodes(state) {
      state.root = [];
      state.expandedNodes = {};
      state.rootLoading = false;
      state.loading = false;
      state.error = null;
    },
    setHsRootLoading(state, action) {
      state.rootLoading = action.payload;
    },
    setHsCodesLoading(state, action) {
      state.loading = action.payload;
    },
    setHsCodesError(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  setHsRoot,
  setChildren,
  clearHsCodes,
  setHsRootLoading,
  setHsCodesLoading,
  setHsCodesError,
} = hsCodesStore.actions;

export default hsCodesStore.reducer;
